import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import { get, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  ADD_PARTNER_BRANCH,
  ADDRESS_LIST,
  CITIES_SEARCH,
  COUNTRIES_SEARCH,
  DISTRICTS_SEARCH,
  ITEMS_SEARCH,
  LANGUAGES_SEARCH,
  PARTNERS_SEARCH,
  SUBDISTRICTS_SEARCH,
  TIMESLOT_LIST,
  SEARCH_TIMESLOT,
} from "helpers/api_endpoints"
import Select from "react-select"
import MapComponent from "components/Common/MapSelect"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"
import AddAddress from "pages/Addresses/AddAddress"
import AddressForm from "../../components/Common/AddressForm"

document.title = "Add Partner Branch"

const AddPartnerBranch = ({ setPartner = null, branchData = null }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState([])

  const [page, setPage] = useState(1)
  const [partnerId, setPartnerId] = useState(0)
  const [itemId, setItemId] = useState(0)
  const [name, setName] = useState('{"title":[{"1":""}]}')
  const [named, setNamed] = useState("")
  const [pickupLocation, setPickupLocation] = useState(0)
  const [preparationTime, setPreparationTime] = useState(30)
  const [deliveryTime, setDeliveryTime] = useState(30)
  const [driverTipsPercentage, setDriverTipsPercentage] = useState(100)
  const [status, setStatus] = useState(1)
  const [regularDeliveryAddresses, setRegularDeliveryAddresses] = useState([])
  const [expressDeliveryAddresses, setExpressDeliveryAddresses] = useState([])
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([])
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false)
  const [isPAddressModalOpen, setIsPAddressModalOpen] = useState(false)
  const [isCoverageAreaAddress, setIsCoverageAreaAddress] = useState(false)
  const [addressTarget, setAddressTarget] = useState(null)
  const [bookedAssignmentTime, setBookedAssignmentTime] = useState(30)
  const [successMsg, setSuccessMsg] = useState("")

  const [partners, setPartners] = useState([])
  const [items, setItems] = useState([])
  const [addresses, setAddresses] = useState([])
  const [timeSlots, setTimeSlots] = useState([])
  const [languages, setLanguages] = useState([])
  const user = JSON.parse(localStorage.getItem("authUser")).user

  const fetchPartners = async () => {
    setLoading(true)
    try {
      const response = await post(
        PARTNERS_SEARCH,
        user.partner ? { id: user.partner.id } : {}
      )
      const formattedPartners = response.data.map(el => ({
        value: el.id,
        label: el.name,
      }))
      setPartners(formattedPartners)
      if (formattedPartners.length == 1)
        setPartnerId(formattedPartners[0].value)
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch partners"
      setErrorMsg(Array.isArray(errorMessage) ? errorMessage : [errorMessage])
    } finally {
      setLoading(false)
    }
  }

  const fetchLanguages = async () => {
    setLoading(true)
    try {
      const response = await post(LANGUAGES_SEARCH)
      setLanguages(response.data)
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch languages"
      setErrorMsg(Array.isArray(errorMessage) ? errorMessage : [errorMessage])
    } finally {
      setLoading(false)
    }
  }

  const fetchItems = async () => {
    setLoading(true)
    try {
      const response = await post(ITEMS_SEARCH)
      const formattedItems = response.data.map(el => ({
        value: el.id,
        label: el.name,
      }))
      setItems(formattedItems)
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch items"
      setErrorMsg(Array.isArray(errorMessage) ? errorMessage : [errorMessage])
    } finally {
      setLoading(false)
    }
  }

  const fetchAddresses = async () => {
    setLoading(true)
    try {
      const response = await get(ADDRESS_LIST)

      const formattedAddresses = response.data.map(el => ({
        value: el.id,
        label: [
          el.title,
          el.street,
          el.flatNo && `Flat ${el.flatNo}`,
          el.subDistrict?.nameTranslated || el.subDistrict?.name,
          el.district?.nameTranslated || el.district?.name,
          el.city?.nameTranslated || el.city?.name,
          el.country?.nameTranslated || el.country?.name,
        ]
          .filter(Boolean)
          .join(", "),
        data: el,
      }))

      console.log("formattedAddresses", formattedAddresses)

      setAddresses(formattedAddresses)
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch addresses"
      setErrorMsg(Array.isArray(errorMessage) ? errorMessage : [errorMessage])
    } finally {
      setLoading(false)
    }
  }

  const fetchTimeSlots = async () => {
    setLoading(true)
    try {
      const response = await post(SEARCH_TIMESLOT)
      const formattedTimeSlots = response.data.map(slot => {
        let label = slot.name

        if (slot.TimeslotDetails?.length > 0) {
          const details = slot.TimeslotDetails.map(
            d => `${d.timeFrom} - ${d.timeTo}`
          ).join(", ")
          label += ` (${details})`
        }

        return {
          value: slot.id,
          label,
          data: slot, // include full slot object if needed
        }
      })

      setTimeSlots(formattedTimeSlots)
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to fetch time slots"
      setErrorMsg(Array.isArray(errorMessage) ? errorMessage : [errorMessage])
    } finally {
      setLoading(false)
    }
  }

  const handleName = (languageId, value) => {
    if (!named.title) {
      setNamed({ title: [{ 1: value }] })
      return
    }
    const ln = named.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      named.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(named))
  }

  const isOverlap = (slotA, slotB) => {
    const parseTime = timeStr => {
      const [hours, minutes, seconds] = timeStr.split(":").map(Number)
      return hours * 60 + minutes + (seconds || 0)
    }

    return slotA.TimeslotDetails?.some(detailA =>
      slotB.TimeslotDetails.some(detailB => {
        const startA = parseTime(detailA.timeFrom)
        const endA = parseTime(detailA.timeTo)
        const startB = parseTime(detailB.timeFrom)
        const endB = parseTime(detailB.timeTo)
        return startA < endB && startB < endA // Overlap
      })
    )
  }

  const handleAddressSelection = (type, selectedOptions) => {
    // Get full address objects from the selected options
    const selectedAddresses = selectedOptions.map(option => option.data)

    // Update state based on the address type
    if (type === "regular") {
      setRegularDeliveryAddresses(selectedAddresses)
    } else {
      setExpressDeliveryAddresses(selectedAddresses)
    }
  }

  const customFilterOption = (option, inputValue) => {
    const search = inputValue.toLowerCase()
    const addressData = option.data

    // Combine searchable fields into one string
    const searchableText = [
      option.label,
      addressData?.title,
      addressData?.street,
      addressData?.flatNo,
      addressData?.subDistrict?.nameTranslated ||
        addressData?.subDistrict?.name,
      addressData?.district?.nameTranslated || addressData?.district?.name,
      addressData?.city?.nameTranslated || addressData?.city?.name,
      addressData?.country?.nameTranslated || addressData?.country?.name,
    ]
      .filter(Boolean) // remove null/undefined
      .join(" ")
      .toLowerCase()

    return searchableText.includes(search)
  }

  useEffect(() => {
    if (branchData) {
      setPartnerId(branchData.partnerId)
      setItemId(branchData.itemId)
      setName(branchData.name)
      setNamed(JSON.parse(branchData.name))
      setStatus(branchData.status)
      setPreparationTime(branchData.preparationTime)
      setDeliveryTime(branchData.deliveryTime)
      setSelectedTimeSlots(
        timeSlots.filter(slotId => {
          return branchData.timeSlots.includes(slotId.value)
        })
      )
      setRegularDeliveryAddresses(
        branchData.regularDeliveryAddresses.map(el => {
          return { id: el }
        })
      )
      setExpressDeliveryAddresses(
        branchData.expressDeliveryAddresses.map(el => {
          return { id: el }
        })
      )
      setPickupLocation(branchData.pickupLocation)
    }
    fetchPartners()
    fetchItems()
    fetchTimeSlots()
    fetchLanguages()
  }, [])

  useEffect(() => {
    fetchAddresses()
  }, [isAddressModalOpen])

  const handleFilter = (type, value, ev = "") => {
    if (!value && value !== 0) return

    switch (type) {
      case "partnerId":
        setPartnerId(value)
        break
      case "itemId":
        setItemId(value)
        break
      case "pickupLocation":
        setPickupLocation(value)
        break
      default:
        break
    }
  }

  const validateBranchData = () => {
    const errors = []

    // Validate partner ID (only if not coming from partner creation flow)
    if (!setPartner && (!partnerId || partnerId === 0)) {
      errors.push("Partner is required")
    }

    if (!itemId || itemId === 0) {
      errors.push("Partner Item is required")
    }

    if (!name || name === '{"title":[{"1":""}]}') {
      errors.push("Branch name is required")
    }

    if (!selectedTimeSlots || selectedTimeSlots.length === 0) {
      errors.push("At least one time slot is required")
    }

    if (!regularDeliveryAddresses || regularDeliveryAddresses.length === 0) {
      errors.push("At least one regular delivery coverage area is required")
    }

    if (!expressDeliveryAddresses || expressDeliveryAddresses.length === 0) {
      errors.push("At least one express delivery coverage area is required")
    }

    if (!pickupLocation || pickupLocation === 0) {
      errors.push("Pickup location is required")
    }

    if (!preparationTime || preparationTime < 1) {
      errors.push("Preparation time must be at least 1 minute")
    }

    if (!deliveryTime || deliveryTime < 1) {
      errors.push("Delivery time must be at least 1 minute")
    }

    if (!bookedAssignmentTime || bookedAssignmentTime < 1) {
      errors.push("Booking assignment time must be at least 1 minute")
    }

    return errors
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    setErrorMsg([])

    try {
      const validationErrors = validateBranchData()
      if (validationErrors.length > 0) {
        setErrorMsg(validationErrors)
        setLoading(false)
        window.scrollTo({ top: 0, behavior: "smooth" })
        return
      }

      const branchData = {
        partnerId: Number(partnerId),
        itemId: Number(itemId),
        name,
        symbol: "PARTNERBRANCH",
        groupId: 0,
        bookedAssignmentTime: Number(bookedAssignmentTime),
        driverTipsPercentage: Number(driverTipsPercentage),
        status: Number(status),
        timeSlots: selectedTimeSlots.map(slot => slot.value),
        regularDeliveryAddresses: regularDeliveryAddresses.map(addr => addr.id),
        expressDeliveryAddresses: expressDeliveryAddresses.map(addr => addr.id),
        pickupLocation: Number(pickupLocation),
        preparationTime: Number(preparationTime),
        deliveryTime: Number(deliveryTime),
      }

      if (setPartner) {
        setPartner(branchData)
        return
      }

      const response = await post(ADD_PARTNER_BRANCH, branchData)

      if (response.code === 201) {
        navigate(`/partnersbranch`, {
          state: { successMsg: "Partner Branch Added Successfully" },
        })
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Failed to add partner branch"
      const errorArray = Array.isArray(errorMessage)
        ? errorMessage
        : [errorMessage]
      setErrorMsg(errorArray)
      console.error("Error adding partner branch:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Partner Branches" breadcrumbItem="Add Branch" />

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    {errorMsg.length > 0 && (
                      <Alert color="danger">
                        <ul className="mb-0">
                          {errorMsg.map((msg, idx) => (
                            <li key={idx}>{msg}</li>
                          ))}
                        </ul>
                      </Alert>
                    )}
                    {successMsg && <Alert color="success">{successMsg}</Alert>}

                    <Row>
                      {!setPartner ? (
                        <div className="form-group col-md-6 mb-2">
                          <Label className="form-label">
                            <Trans>Partner</Trans>
                          </Label>
                          <Select
                            name="partnerId"
                            options={partners}
                            value={partners.filter(option => {
                              return partnerId == option.value
                            })}
                            className="form-control select2"
                            onChange={e => handleFilter("partnerId", e.value)}
                          />
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="form-group col-md-6 mb-2">
                        <Label className="form-label">
                          <Trans>Partner Item</Trans>
                        </Label>
                        <Select
                          name="itemId"
                          options={items}
                          value={items.filter(option => {
                            return itemId == option.value
                          })}
                          className="form-control select2"
                          onChange={e => handleFilter("itemId", e.value)}
                        />
                      </div>

                      <div className="form-group col-md-6 mb-2">
                        <Label className="form-label">
                          <Trans>Partner Time Slot</Trans>
                        </Label>
                        <Select
                          name="timeslotIds"
                          options={timeSlots}
                          isMulti
                          value={selectedTimeSlots}
                          className="form-control select2"
                          onChange={selectedOptions => {
                            if (
                              selectedOptions.length > selectedTimeSlots.length
                            ) {
                              const newSlot =
                                selectedOptions[selectedOptions.length - 1]

                              if (newSlot && newSlot.data) {
                                const alreadySelected = selectedTimeSlots.map(
                                  slot => slot.data
                                )

                                const hasConflict = alreadySelected.some(
                                  existing => isOverlap(existing, newSlot.data)
                                )

                                if (hasConflict) {
                                  alert(
                                    "Selected timeslot overlaps with an existing one. Please choose a different timeslot."
                                  )
                                  return
                                }
                              }
                            }

                            // Update the state (for both adding and removing)
                            setSelectedTimeSlots(selectedOptions)
                          }}
                          placeholder="Select one or more time slots"
                          closeMenuOnSelect={false}
                        />
                      </div>

                      <Row className="my-3">
                        {languages.map((language, index) => (
                          <div className="form-group col-md-3 mt-2" key={index}>
                            <Label className="form-label">
                              <Trans>Name ({language.name})</Trans>
                            </Label>
                            <Input
                              name="name"
                              value={
                                named.title
                                  ? named.title.find(el => {
                                      return el[language.id]
                                    })
                                    ? named.title.find(el => {
                                        return el[language.id]
                                      })[language.id]
                                    : ""
                                  : ""
                              }
                              className="form-control"
                              placeholder="Enter Name"
                              type="text"
                              onChange={e =>
                                handleName(language.id, e.target.value)
                              }
                              required={
                                language.id == 1 || language.id == 2
                                  ? true
                                  : false
                              }
                            ></Input>
                            <Input type="hidden" name="id"></Input>
                          </div>
                        ))}
                      </Row>

                      <Row>
                        {/* Regular Delivery Addresses */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              <Trans>Regular Delivery Coverage Areas</Trans>
                            </Label>
                            <Select
                              isMulti
                              name="regularDeliveryAddresses"
                              options={addresses}
                              value={addresses.filter(option =>
                                regularDeliveryAddresses.some(
                                  addr => addr.id === option.value
                                )
                              )}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              onChange={selected =>
                                handleAddressSelection("regular", selected)
                              }
                              closeMenuOnSelect={false}
                              placeholder="Select addresses for regular delivery..."
                              filterOption={customFilterOption}
                            />
                            <Button
                              onClick={() => {
                                setIsAddressModalOpen(true)
                                setAddressTarget("regular")
                                setIsCoverageAreaAddress(true)
                              }}
                              color="danger"
                              required
                            >
                              Create Address +
                            </Button>
                          </div>
                        </Col>

                        {/* Express Delivery Addresses */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              <Trans>Express Delivery Coverage Areas</Trans>
                            </Label>
                            <Select
                              isMulti
                              name="expressDeliveryAddresses"
                              options={addresses}
                              value={addresses.filter(option =>
                                expressDeliveryAddresses.some(
                                  addr => addr.id === option.value
                                )
                              )}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              onChange={selected =>
                                handleAddressSelection("express", selected)
                              }
                              closeMenuOnSelect={false}
                              placeholder="Select addresses for express delivery..."
                              filterOption={customFilterOption}
                            />
                            <Button
                              onClick={() => {
                                setIsAddressModalOpen(true)
                                setAddressTarget("express")
                                setIsCoverageAreaAddress(true)
                              }}
                              color="danger"
                              required
                            >
                              Create Address +
                            </Button>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <div className="form-group mb-3 col-md-3">
                          <Label>
                            <Trans>Preparation Time (minutes)</Trans>
                          </Label>
                          <Input
                            type="number"
                            min="1"
                            value={preparationTime}
                            onChange={e => setPreparationTime(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group mb-3 col-md-3">
                          <Label>
                            <Trans>Delivery Time (minutes)</Trans>
                          </Label>
                          <Input
                            type="number"
                            min="1"
                            value={deliveryTime}
                            onChange={e => setDeliveryTime(e.target.value)}
                            required
                          />
                        </div>

                        <div className="form-group mb-3 col-md-3">
                          <Label>
                            <Trans>Booking Assignment Time (minutes)</Trans>
                          </Label>
                          <Input
                            type="number"
                            min="1"
                            value={bookedAssignmentTime}
                            onChange={e =>
                              setBookedAssignmentTime(e.target.value)
                            }
                            required
                          />
                        </div>

                        <div className="form-group mb-3 col-md-3">
                          <Label>
                            <Trans>Driver tips percentage</Trans>
                          </Label>
                          <Input
                            type="number"
                            min="1"
                            value={driverTipsPercentage}
                            onChange={e =>
                              setDriverTipsPercentage(e.target.value)
                            }
                            required
                          />
                        </div>

                        <div className="form-group mb-3 col-md-3">
                          <Label>
                            <Trans>Status</Trans>
                          </Label>
                          <Input
                            type="select"
                            value={status}
                            onChange={e => setStatus(parseInt(e.target.value))}
                            required
                          >
                            <option value={1}>Active</option>
                            <option value={2}>Inactive</option>
                          </Input>
                        </div>

                        <div className="form-group mb-3">
                          <Label>
                            <Trans>Pickup Location (Full Address)</Trans>
                          </Label>
                          <Select
                            name="pickupLocation"
                            options={addresses}
                            value={addresses.filter(option => {
                              return pickupLocation == option.value
                            })}
                            className="form-control select2"
                            onChange={e =>
                              handleFilter("pickupLocation", e.value)
                            }
                            filterOption={customFilterOption}
                            required
                          />

                          <Button
                            onClick={() => {
                              setIsPAddressModalOpen(true)
                            }}
                            color="danger"
                          >
                            Create Address +
                          </Button>
                        </div>
                      </Row>
                    </Row>

                    <div className="mt-4">
                      <Button type="submit" color="primary" disabled={loading}>
                        {loading ? "Processing..." : "Submit"}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>

          <Modal
            isOpen={isAddressModalOpen}
            toggle={() => setIsAddressModalOpen(!isAddressModalOpen)}
            size="lg"
            zIndex={900}
          >
            <ModalHeader toggle={() => setIsAddressModalOpen(false)}>
              Create New Address
            </ModalHeader>
            <ModalBody>
              <AddressForm
                mode={1}
                showMap={false}
                express={true}
                showBoundries={true}
                onSuccess={createdAddress => {
                  setIsAddressModalOpen(false)

                  const formatted = {
                    value: createdAddress.id,
                    label: [
                      createdAddress.title,
                      createdAddress.street,
                      createdAddress.flatNo && `Flat ${createdAddress.flatNo}`,
                      createdAddress.subDistrict?.nameTranslated ||
                        createdAddress.subDistrict?.name,
                      createdAddress.district?.nameTranslated ||
                        createdAddress.district?.name,
                      createdAddress.city?.nameTranslated ||
                        createdAddress.city?.name,
                      createdAddress.country?.nameTranslated ||
                        createdAddress.country?.name,
                    ]
                      .filter(Boolean)
                      .join(", "),
                    data: createdAddress,
                  }

                  // Add to addresses for Select
                  setAddresses(prev => [...prev, formatted])

                  // Add to correct selection based on target
                  if (addressTarget === "pickup") {
                    setPickupLocation(createdAddress.id)
                  } else if (addressTarget === "regular") {
                    setRegularDeliveryAddresses(prev => [
                      ...prev,
                      formatted.data,
                    ]) // ✅ use formatted.data
                  } else if (addressTarget === "express") {
                    setExpressDeliveryAddresses(prev => [
                      ...prev,
                      formatted.data,
                    ]) // ✅ use formatted.data
                  }

                  setSuccessMsg("Address created successfully!")
                  setTimeout(() => setSuccessMsg(""), 5000)
                }}
                onCancel={() => setIsAddressModalOpen(false)}
                isAddressForCoverageArea={isCoverageAreaAddress ? true : false}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={isPAddressModalOpen}
            toggle={() => setIsPAddressModalOpen(!isPAddressModalOpen)}
            size="lg"
            zIndex={900}
          >
            <ModalHeader toggle={() => setIsPAddressModalOpen(false)}>
              Create New Address
            </ModalHeader>
            <ModalBody>
              <AddressForm
                mode={1}
                showMap={true}
                addressId={pickupLocation}
                express={true}
                onSuccess={data => {
                  const temp = [...addresses]
                  temp.push({ value: data.id, label: data.title, data: data })
                  setAddresses(temp)
                  setPickupLocation(Number(data.id))
                  setIsPAddressModalOpen(false)
                }}
                onCancel={() => setIsPAddressModalOpen(false)}
              />
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddPartnerBranch
